import React, { useEffect, useRef, useState } from 'react'
import {
  Modal,
  Button,
  Form,
  Divider,
  Tooltip,
  message,
  Row,
  Select,
  Spin,
  Collapse,
  Popover,
  Checkbox,
} from 'antd'
import { connect } from 'react-redux'
import './index.scss'
import {
  MinusSmallIco,
  ModalCloseIco,
  PlusSmallIco,
  SaveBlueIco,
  SpinnerIco,
} from '../../../modules/CustomIcons'
import TableComponent from 'components/Table'
import { LOGIN_PAGE } from 'constants/constants'
import { CountdownCircleTimer } from 'react-countdown-circle-timer'
import asanLogo from 'assets/images/icons/asan-logo.png'
import questionMark from 'assets/images/icons/question.png'
import SuccessOrErrorModal from 'components/SuccessOrErrorModal'
import {
  getTransactionButtons,
  RuleTransactionButton,
} from '../../services/Auth/RuleTransactionButton'
import { API_URL, httpVeryfied } from '../../services/config'
import OtpInput from 'react-otp-input'
import Timer from 'components/Timer'
import '../../pages/Login/components/Sidebar/MessageInput/index.scss'
import { getTransactionStatus } from '../../services/Auth/TransactionStatus'
// import {changeStatus} from '../../store/actions/transfers'
import { Scrollbar } from 'smooth-scrollbar-react'
import type { Scrollbar as BaseScrollbar } from 'smooth-scrollbar/scrollbar'
import { useActions } from '../../hooks/useActions'
import { changeStatusHandler } from 'store/actions/transfers'
import { convertBase64, financial, resetForm } from '../../services/helper'
import { uploadFile } from '../../services/Transfers/Files'
import {
  footerBtnsFirstModal,
  footerBtnsSecondSalary,
} from 'pages/Transfers/StatusRender'
import SaveAsTemplate from 'components/SaveAsTemplate'
import { getAllFilesOrderPdfByName, getRekvizitIbanRefMultiple } from '../../services/transfers'
import { secureLocalStorageGet } from '../../helpers'
import { useTranslation } from 'react-i18next'
import { getAccounts } from '../../services/account'
import { getCurrentCompany } from '../../services/user'
import { getAccountType } from '../../services/Transfers/GetCustomerByIban'

const formatRemainingTime = (time: number) => {
  const minutes = Math.floor((time % 1200) / 60)
  const seconds = time % 60

  return `0${minutes}:${seconds == 0 || seconds < 10 ? `0${seconds}` : seconds}`
}

const renderTime = ({ remainingTime }) => {
  if (remainingTime === 0) {
    return <div className="timer"></div>
  }

  return (
    <div className="timer">
      <div className="value">{formatRemainingTime(remainingTime)}</div>
    </div>
  )
}

const NextModal: React.FC<any> = (props: any) => {
  const { t } = useTranslation()
  let custom_class = props.className || ''
  const [nextModalVisible, setNextModalVisible] = useState(
    props.visible || false
  )
  const text = (
    <div className="ant-tooltip-inner__data">
      {t('settings.asanInfo')}
      <br />
      <span>
        <a href="https://www.asanimza.az" target="_blank">
          www.asanimza.az
        </a>
      </span>
    </div>
  )
  const [asanModalVisible, setAsanModalVisible] = useState(false)
  const [otpCodeModalVisible, setOtpCodeModalVisible] = useState(false)
  const [showSuccessOrError, setShowSuccessOrError] = useState(false)
  const [transactionButtonsStatus, setTransactionButtonsStatus] =
    useState<RuleTransactionButton>()
  const [verifyCode, setVerifyCode] = useState<number>()
  const [phoneNumber, setPhoneNumber] = useState<string>()
  const [otpNumberCount, setOtpNumberCount] = useState<number>(6)
  const [otpCode, setOtpCode] = useState<number[]>([])
  const [otpCodeHasError, setOtpCodeHasError] = useState<boolean>(false)
  const modalData = props.data
  const [popupType, setPopupType] = useState('success')
  const [form] = Form.useForm()
  const scrollbar = useRef<BaseScrollbar | null>(null)
  const [minutes, setMinutes] = useState<number>(5)
  const [reset, setReset] = useState<boolean>(false)
  const [modalText, setModalText] = useState<string>(props.nextModalText)
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingApprove, setLoadingApprove] = useState<boolean>(false)
  const [errorService, setErrorService] = useState('')
  const [saveAsTemplatePopupVisible, setSaveAsTemplatePopupVisible] =
    useState<boolean>(false)
  let channel = secureLocalStorageGet('channel')
  const [smsClicked, setClicked] = useState(true)
  const selectOptions = ['AZ', 'EN', 'RU']
  const { Panel } = Collapse
  const [activePanel, setPanel] = useState(false)
  const [activePanelNotify, setPanelNotify] = useState(false)
  const [multipleButton, setMultipleButton] = useState(false)
  const [footerBtnsSecond, setFooterBtnsSecond] = useState(
    footerBtnsSecondSalary
  )
  const [footerBtnsFirst, setFooterBtnsFirst] = useState(footerBtnsFirstModal)
  const [visible, setVisible] = useState(false)
  const [loadingExcel, setLoadingExcel] = useState(false)
  const [selectedValue, setSelectedValue] = useState('AZ')
  const [selectLang, setLanguage] = useState('AZ')
  const [accounts, setAccounts] = useState([])
  const [accountsModal, setAccountsModal] = useState(false)
  const [selectedAccounts, setSelectedAccounts] = useState<{ iban: string }[]>(
    []
  )
  const [rekvizitLoad, setRekvizitLoad] = useState(false)
  const handleChangeSelect = (value: string) => {
    
    setSelectedValue(value)
  }

  const content = (
    <div>
      <p
        onClick={() => props.handleGetFileClick(selectLang)}
        className={'pdf_text'}
      >
        {t('transfers.seperatePDF')}
      </p>
      <p onClick={props.handleGetFileClickMultiple} className={'pdf_text'}>
        {t('transfers.multiplePDF')}
      </p>
    </div>
  )

  useEffect(() => {
    setErrorService('')
    setModalText(props.nextModalText)
    setNextModalVisible((old_value) => props.visible)
    if (!props.source) {
      getTransactionButtons().then((res) => {
        setTransactionButtonsStatus((olda_data) => res)
      })
    }
  }, [props.visible, props.data])

  useEffect(() => {
    setPanel(false)
    setPanelNotify(false)
    let template = false
    if (
      props.data !== undefined &&
      props.data['modalTitle'] === t('home.currencyExchange')
    )
      template = true
    if (props.btnData !== undefined && props.btnData !== {}) {
      footerBtnsSecond[0]['visible'] = props.btnData['singlePdfButton']
      footerBtnsSecond[1]['visible'] = props.btnData['excelButton']
      footerBtnsSecond[2]['visible'] = props.btnData['swiftButton']
      footerBtnsSecond[3]['visible'] = props.btnData['adocButton']
      footerBtnsFirst[0]['visible'] = props.btnData['repeatButton']
      footerBtnsFirst[1]['visible'] = props.btnData['editButton']
      if (!template)
        footerBtnsFirst[2]['visible'] = props.btnData['saveAsTemplateButton']
      else footerBtnsFirst[2]['visible'] = false
      footerBtnsFirst[3]['visible'] = props.btnData['deleteButton']
    } else {
      footerBtnsSecond[0]['visible'] = false
      footerBtnsSecond[1]['visible'] = false
      footerBtnsSecond[2]['visible'] = false
      footerBtnsFirst[0]['visible'] = false
      footerBtnsFirst[1]['visible'] = false
      footerBtnsFirst[2]['visible'] = false
      footerBtnsFirst[3]['visible'] = false
    }
    if (props.multiple) {
      setMultipleButton(true)
    } else {
      setMultipleButton(false)
    }
  }, [props.selectedType, props.multiple, props.data])

  const onClose = () => {
    //props.onClose((old_value) => false)

    setNextModalVisible(false)
    setAsanModalVisible(false)
    setOtpCodeModalVisible(false)
    setShowSuccessOrError(false)

    /*setTimeout(() => {
      window.location.reload();
    }, 500)*/
  }

  const onCloseModal = () => {
    props.onClose((old_value) => false)

    setNextModalVisible(false)
    setAsanModalVisible(false)
    setOtpCodeModalVisible(false)
    setShowSuccessOrError(false)

    /*setTimeout(() => {
      window.location.reload();
    }, 500)*/
  }

  const onCloseSuccessModal = () => {
    if (
      props.onCloseSuccessModal !== null &&
      props.onCloseSuccessModal !== undefined
    ) {
      props.onCloseSuccessModal((old_value) => false)
    }

    props.onClose((old_value) => false)
    setNextModalVisible(false)
    setAsanModalVisible(false)
    setOtpCodeModalVisible(false)
    setShowSuccessOrError(false)

    /*setTimeout(() => {
      window.location.reload();
    }, 500)*/
  }

  const showSuccessModal = () => {
    setShowSuccessOrError((old_status) => true)
    if (props.currentForm) {
      resetForm(props.currentForm)
    }
  }

  const showAsanModal = () => {
    // setNextModalVisible(false)
    setAsanModalVisible(true)
  }

  const showOtpCodeModal = () => {
    // setNextModalVisible(false)
    setOtpCodeModalVisible(true)
    setClicked(false)
    setOtpCode((old_data) => [])
    setOtpCodeHasError((old_data) => false)
  }

  const hideOtpCodeModal = () => {
    setNextModalVisible(true)
    setOtpCodeModalVisible(false)
  }

  const checkAsanVerifyCode = (code: number) => {
    setPopupType('success')
    return new Promise((resolve, reject) => {
      function checkResponse() {
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            let data = response.data.data
            if (
              data.lastStatus == 'SIGNATURE_CREATED' &&
              response.data.status == 'SUCCESS'
            ) {
              setModalText(props.nextModalText)
              setPopupType('success')
              setAsanModalVisible(false)
              showSuccessModal()
            } else if (data.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              setAsanModalVisible(false)
              setModalText(
                response.data.message !== null ? response.data.message : ''
              )
              setPopupType('error')
              showSuccessModal()
            }
          })
      }
      checkResponse()
    })
  }

  const checkAsanVerifyCodeTransfers = (code: number) => {
    setPopupType('success')
    return new Promise((resolve, reject) => {
      function checkResponse() {
        httpVeryfied()
          .get(`${API_URL}transaction/status/${code}`)
          .then((response: any) => {
            let data = response.data.data
            if (
              data.lastStatus == 'SIGNATURE_CREATED' &&
              response.data.status == 'SUCCESS'
            ) {
              setModalText(props.nextModalText)
              setPopupType('success')
              setAsanModalVisible(false)
              showSuccessModal()
            } else if (data.lastStatus == 'OUTSTANDING_TRANSACTION') {
              window.setTimeout(checkResponse, 1000)
            } else {
              setAsanModalVisible(false)
              setModalText(
                response.data.message !== null ? response.data.message : ''
              )
              setPopupType('error')
              showSuccessModal()
            }
          })
      }
      checkResponse()
    })
  }

  const saveFilesExcel = async (PMTID: string, pdfFiles: any) => {
    let returnValue = false
    let fileDetailsList = {
      fileDetailsList: [],
    }
    if (pdfFiles && pdfFiles.length > 0) {
      for (let file of pdfFiles) {
        let convert = await convertBase64(file)

        fileDetailsList['fileDetailsList'].push({
          fileBase64: convert,
          pmtid: PMTID,
          fileName: file.name,
          mimeType: 'application/vnd.ms-excel',
        })
      }
      const res = await uploadFile(fileDetailsList)
      if (res?.status === 'SUCCESS') returnValue = true
    }

    return returnValue
  }

  const saveFiles = async (ibankRef: string, PMTID: string) => {
    let formData = props.data
    let pdfFiles = formData.pdfFiles
    let fileDetailsList = {
      fileDetailsList: [],
    }
    if (pdfFiles && pdfFiles.length > 0) {
      for (let file of pdfFiles) {
        let convert = await convertBase64(
          file.file.originFileObj !== undefined
            ? file.file.originFileObj
            : file.file
        )

        fileDetailsList['fileDetailsList'].push({
          fileBase64: convert,
          pmtid: PMTID,
          fileName: file.file.name,
          mimeType: file.file.type,
        })
      }

      uploadFile(fileDetailsList)
    }
  }

  const sendTransactionRequest = async (
    RequestType: string,
    retry: boolean
  ) => {
    setPopupType('success')
    setErrorService('')
    // setClicked(false)
    if (RequestType === 'SAVE') setLoading(true)
    else setLoadingApprove(true)
    var response = await saveFilesExcel(
      props.documentNumber,
      props.fileListSalary
    )
    if (response) {
      props
        .callBackApi(RequestType, retry, props.fileListSalary)
        .then((res: any) => {
          setLoading(false)
          setLoadingApprove(false)
          if (res?.status === 'SUCCESS' || res?.resultMessage === 'SUCCESS') {
            saveFiles(res.data?.ibankRef, res.data?.PMTID)
            if (RequestType === 'SAVE') {
              onClose()
              setModalText(
                'Əməliyyat uğurla saxlanılmışdır və avtorizasiyanı gözləməkdədir.'
              )
              showSuccessModal()
            } else if (RequestType === 'APPROVE') {
              // setNextModalVisible(false)
              showSuccessModal()
            } else {
              let channel = secureLocalStorageGet('channel')
              if (channel === 'TOTP' || channel === 'OTP') {
                let phone_number = res.data?.phoneNumber
                let last_4_number = phone_number.slice(-4)
                let make_phone_number =
                  last_4_number[0] +
                  last_4_number[1] +
                  '-' +
                  last_4_number.slice(-2)

                setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))
                setPhoneNumber((old_data) => make_phone_number)
                showOtpCodeModal()
              } else {
                let verify_code = res.data.verification
                setVerifyCode((old_code) => verify_code)
                checkAsanVerifyCode(verify_code)
                showAsanModal()
              }
            }
          } else {
            setLoading(false)
            setLoadingApprove(false)
            setErrorService(res?.detail + ' ' + res?.message)
          }
        })
        .catch((e: any) => {
          setLoading(false)
          setLoadingApprove(false)
          setErrorService(e?.data?.detail)
        })
    } else {
      setLoading(false)
      setLoadingApprove(false)
      setErrorService('Error save excel')
    }
  }

  const sendTransactionApprove = async (RequestType: any, retry: boolean) => {
    setPopupType('success')
    setErrorService('')
    setLoadingApprove(true)
    const response = await saveFilesExcel(
      props.documentNumber,
      props.fileListSalary
    )
    if (response) {
      props
        .callBackApi(RequestType, retry, props.fileListSalary)
        .then((res) => {
          // saveFilesExcel(res.data?.ibankRef, res.data?.PMTID, props.fileListSalary)
          setLoadingApprove(false)
          if (res?.status === 'SUCCESS' || res?.resultMessage === 'SUCCESS') {
            if (RequestType === 'APPROVE') {
              setNextModalVisible(false)

              showSuccessModal()
            } else {
              let channel = secureLocalStorageGet('channel')
              if (channel === 'TOTP' || channel === 'OTP') {
                setOtpNumberCount((old_number) => (channel === 'TOTP' ? 6 : 5))
                showOtpCodeModal()
              } else {
                setVerifyCode((old_code) => res.verfication)
                showAsanModal()
                checkAsanVerifyCodeTransfers(res.verfication)
              }
            }
          } else {
            setErrorService(res?.detail + ' ' + res?.message)
          }
        })
        .catch((e) => {
          setLoading(false)
          setLoadingApprove(false)
          setErrorService(e?.data?.detail)
        })
    } else {
      setErrorService('Error save excel')
    }
    setLoadingApprove(false)
  }

  const handleTransactionReq = async () => {
    if (props.btnType) {
      await sendTransactionApprove(props.requestType, false)
    } else {
      await sendTransactionRequest('SIGN', false)
    }
  }

  const handleValue = (value: any) => {
    setOtpCode(value)
  }

  const checkOTPCode = () => {
    if (otpCode.length == 5 || otpCode.length == 6) {
      setLoading(true)
      getTransactionStatus(otpCode)
        .then((res) => {
          if (res.status === 'ERROR' && res.code === 3) {
            setOtpCodeHasError((old_data) => true)
          } else if (res.status === 'ERROR' && res.code === 5) {
            setOtpCodeHasError((old_data) => true)
          } else if (
            res.status === 'ERROR' &&
            res.code === 500 &&
            props.transfer === true
          ) {
            setOtpCodeHasError((old_data) => false)
            setOtpCodeModalVisible(false)
            setModalText(t('notification.errorOccuredWhenSendToBank'))
            setPopupType('error')
            showSuccessModal()
          } else {
            setPopupType('success')
            // setModalText("Əməliyyat uğurla saxlanılmış, imzalanmışdır və banka göndərilməsini gözləməkdədir.")
            // changeStatusHandler()
            setLoading(false)

            setOtpCodeHasError(() => false)
            setOtpCodeModalVisible(false)
            showSuccessModal()

            // props.onStatusChange(true)
          }
        })
        .catch((err) => {
          setLoading(false)
        })
    }
  }

  const resetFormTimer = () => {
    // inputRef.current.__clearvalues__()
  }

  const reSend = () => {
    if (smsClicked) {
      setClicked(false)
      sendTransactionRequest('SIGN', true)
    }
    // setMinutes(5);
    // setReset(true);
    // setTimeout(() => setReset(false), 1000);
  }

  const downloadPDF = async (file: any) => {
    let fileBase64 = await convertBase64(
      file.file.originFileObj !== undefined
        ? file.file.originFileObj
        : file.file
    )
    const fileName = file.label
    const linkSource = `${fileBase64}`
    const downloadLink = document.createElement('a')
    downloadLink.href = linkSource
    downloadLink.download = fileName
    downloadLink.click()
  }

  const handleSave = () => {
    setSaveAsTemplatePopupVisible((old_data) => true)
  }

  useEffect(() => {
    if (!smsClicked) {
      let timer1 = setInterval(() => setClicked(true), 20 * 1000)
      return () => {
        clearInterval(timer1)
      }
    }
  }, [smsClicked])

  const handleGetExcelAdditional = async () => {
    setLoadingExcel(true)
    const tableData = props.tableData
    const result = tableData?.PDF_LIST?.filter(
      (cert) => cert.mimeType === 'application/vnd.ms-excel'
    )
    if (result !== undefined && result.length > 0) {
      const data = await getAllFilesOrderPdfByName(
        tableData.ibankRef,
        result[0].fileName
      )
      // setFileData(data)
      data?.data.fileDetailsList.map(function (item, i) {
        const downloadLink = document.createElement('a')
        downloadLink.href = item.fileBase64
        downloadLink.download = result[0].fileName
        downloadLink.click()
      })
    }
    setLoadingExcel(false)
  }

  const handleSelectAccount = async () => {
    setLoading(true)
    const data = await getAccounts(getCurrentCompany())
    let temp_array: any = []

    for (let row of data) {
      if (row.STATUS !== '0') {
        let tooltip_content = `${row.BRANCH_NAME}-da olan ${
          row.NICKNAME ? row.NICKNAME : getAccountType(row.ACCOUNT_TYPE)
        }`
        tooltip_content += `<br/>Yeni IBAN: ${row.IBAN}`
        tooltip_content += `<br/>Köhnə IBAN: ${row.ORJ_IBAN ?? '-'}`

        let col_6_class_name = ''

        if (parseFloat(row.WFA_AMOUNT) > 0) {
          col_6_class_name = 'is_blue'
        } else if (parseFloat(row.WFA_AMOUNT) < 0) {
          col_6_class_name = 'is_red'
        }
        // @ts-ignore
        temp_array.push({
          key: row.ACCOUNT_NO,
          col_1: {
            title: row.NICKNAME
              ? row.NICKNAME
              : getAccountType(row.ACCOUNT_TYPE),
            subtitle: row.IBAN,
            tooltip: tooltip_content,
            has_cart: row.COMPASSACCOUNT,
            ACCOUNT_TYPE: row.ACCOUNT_TYPE,
          },
          col_2: row.CCY_NAME,
          col_3: financial(row.BALANCE),
          col_4: { title: financial(row.BLOCKSAMOUNT), data: [] },
          col_5: financial(row.REAL_BALANCE),
          col_6: {
            title: financial(row.WFA_AMOUNT),
            data: { className: col_6_class_name },
            rowData: row,
          },
          col_7: financial(row.LAST_BALANCE),
          rowData: row,
          nickname: row.NICKNAME,
          isDropdown: false,
        })
      }
    }
    setAccounts(temp_array)
    setLoading(false)
    setAccountsModal(true)
  }

  // @ts-ignore
  const modalFooter = () => (
    <>
      {modalData.note && (
        <div className="flex tab_info_box ">
          <span
            className="passive_text_box passive_text_box_rel"
            dangerouslySetInnerHTML={{ __html: modalData.note }}
          />
        </div>
      )}

      {modalData.alertText && (
        <div className="flex tab_info_box tab_alert_box">
          <span
            className="passive_text_box passive_text_box_rel"
            dangerouslySetInnerHTML={{ __html: modalData.alertText }}
          />
        </div>
      )}

      {errorService && (
        <div className="flex tab_info_box tab_alert_box">
          <span
            className="passive_text_box passive_text_box_rel"
            dangerouslySetInnerHTML={{ __html: errorService }}
          />
        </div>
      )}
      {props.transferSP ? (
        <div className={'flex flex_wrap modalTransferSpaceBetween'}>
          <div
            className="transfers-footer_btns1 transfers-footer_btns--modal flex"
            style={{ position: 'relative', bottom: 12 }}
          >
            {!multipleButton && (
              <ul className="flex">
                <li>
                  <div
                    className="pagination-selector language-selector"
                    style={{ left: '0px' }}
                  >
                    <Select
                      // open={true}
                      defaultValue={'AZ'}
                      placeholder="AZ"
                      onChange={(value: any) => setLanguage(value)}
                      // width={64}
                    >
                      {selectOptions.map((item) => {
                        return <option value={item}>{item}</option>
                      })}
                    </Select>
                  </div>
                </li>
                {footerBtnsSecond.map((item) => {
                  return (
                    item.visible && (
                      <li>
                        <Tooltip className="footer-tooltip" title={item.title}>
                          {item.key == 'pdf' ? (
                            props.loadingPdf ? (
                              <div className="ant-btn exportLoadingdiv">
                                <Spin indicator={<SpinnerIco />} />
                              </div>
                            ) : props.multiple ? (
                              <Popover
                                // className = "btn-popover"
                                placement="top"
                                content={content}
                                trigger="click"
                                visible={visible}
                                onVisibleChange={() => setVisible(!visible)}
                              >
                                <Button
                                  icon={item.icon}
                                  disabled={!item.visible || loadingApprove}
                                />
                              </Popover>
                            ) : (
                              <Button
                                icon={item.icon}
                                disabled={!item.visible || loadingApprove}
                                onClick={props.handleGetFileClick}
                              />
                            )
                          ) : loadingExcel ? (
                            <div className="ant-btn exportLoadingdiv">
                              <Spin indicator={<SpinnerIco />} />
                            </div>
                          ) : (
                            <Button
                              icon={item.icon}
                              disabled={
                                !item.visible ||
                                loadingApprove ||
                                item.key == 'swift'
                              }
                              onClick={
                                item.key == 'adoc'
                                  ? props.handleGetAdocFileClick
                                  : handleGetExcelAdditional
                              }
                            />
                          )}
                        </Tooltip>
                      </li>
                    )
                  )
                })}
              </ul>
            )}
            {!multipleButton && (
              <ul className="flex" style={{ marginRight: '86px' }}>
                {footerBtnsFirst.map((item) => {
                  return (
                    item.visible && (
                      <li>
                        <Tooltip className="footer-tooltip" title={item.title}>
                          <Button
                            ghost
                            icon={item.icon}
                            disabled={!item.visible || loadingApprove}
                            onClick={
                              item.type === 'repeat'
                                ? props.handleRepeat
                                : item.type === 'edit'
                                ? props.handleEdit
                                : item.type === 'save'
                                ? handleSave
                                : props.handleDelete
                            }
                          />
                        </Tooltip>
                      </li>
                    )
                  )
                })}
              </ul>
            )}
          </div>

          <div className={'flex'}>
            {props.requestType === 'SIGN' &&
            props.selectedType !== 'BANK_ERROR' ? (
              <div className={'modalButtonDivSignTransfer'}>
                {loadingApprove ? (
                  <div className="ant-btn  exportLoadingdiv transfer_loading">
                    <Spin indicator={<SpinnerIco />} />
                  </div>
                ) : (
                  <Button
                    size={'large'}
                    htmlType="submit"
                    className="blue-button next_btn btn flex align_center justify_center"
                    disabled={props.disabledSign}
                    onClick={handleTransactionReq}
                  >
                    {t('transfers.sign')}
                  </Button>
                )}
              </div>
            ) : (
              props.selectedType !== 'BANK_ERROR' && (
                <div className={'modalButtonDivApproveTransfer'}>
                  {loadingApprove ? (
                    <div className="ant-btn exportLoadingdiv transfer_loading">
                      <Spin indicator={<SpinnerIco />} />
                    </div>
                  ) : (
                    <Button
                      size={'large'}
                      htmlType="submit"
                      className="blue-button next_btn btn flex align_center justify_center"
                      disabled={
                        props.selectedType === 'DELETED' || props.disabledSign
                      }
                      onClick={() => {
                        sendTransactionRequest(props.btnType || 'APPROVE')
                      }}
                    >
                      {t('login.confirm')}
                    </Button>
                  )}
                </div>
              )
            )}
            {props.selectedType === 'BANK_ERROR' && (
              <div className={'modalButtonDivApproveTransfer'}>
                {loadingApprove ? (
                  <div className="ant-btn exportLoadingdiv transfer_loading">
                    <Spin indicator={<SpinnerIco />} />
                  </div>
                ) : (
                  <Button
                    size={'large'}
                    htmlType="submit"
                    className="blue-button next_btn btn flex align_center justify_center"
                    onClick={() => {
                      sendTransactionRequest('SEND_BANK')
                    }}
                  >
                    {t('transfers.sendToBank')}
                  </Button>
                )}
              </div>
            )}
            <Button
              size={'large'}
              htmlType="submit"
              className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center"
              onClick={onClose}
              disabled={loadingApprove}
            >
              {t('common.close')}
            </Button>
          </div>
        </div>
      ) : (
        <div className={'flex' + props.source ? props.className : ''}>
          {props.otherButtons.length !== 0 &&
          props.otherButtons !== undefined &&
          props.otherButtons !== null ? (
            <div style={{ display: 'flex' }}>
              <div className="flex">
                <div className="accountStatement-footer_btns accountNextModal-footer_btns transfers-footer_btns flex">
                  <ul className="flex">
                    <li>
                      <div
                        className="pagination-selector"
                        style={{ left: '0px' }}
                      >
                        <Select
                          defaultValue={selectedValue}
                          placeholder="AZ"
                          width={64}
                          onChange={handleChangeSelect}
                          // disabled={tableData ? false : true}
                        >
                          {selectOptions.map((item) => {
                            return <option value={item}>{item}</option>
                          })}
                        </Select>
                      </div>
                    </li>
                    {props.otherButtons.map((item2) => {
                      return (
                        <li>
                          <Tooltip
                            className="footer-tooltip"
                            title={item2.title}
                          >
                            {item2.loading ? (
                              <div className="ant-btn exportLoadingdiv exportLoadingdivRequisite">
                                <Spin indicator={<SpinnerIco />} />
                              </div>
                            ) : (
                              <Button
                                className={'accountPage_exportButtons'}
                                ghost
                                icon={item2.icon}
                                onClick={() =>
                                  item2?.onClickFunc(selectedValue)
                                }
                                disabled={item2.disabled}
                              />
                            )}
                          </Tooltip>
                        </li>
                      )
                    })}
                  </ul>
                </div>
              </div>
            </div>
          ) : (
            <></>
          )}
          <div className={'flex flex_wrap align_center justify_end'}>
            {modalData.buttons &&
              Array.isArray(modalData.buttons) &&
              modalData.buttons.map((btn) => {
                let btn_item = <></>

                if (btn.patternButton) {
                  btn_item = (
                    <Button
                      size={'large'}
                      icon={<SaveBlueIco />}
                      className="light-button btn save_btn flex align_center justify_center refresh_btn next_modal_cancel_btn"
                      htmlType="submit"
                      disabled={loading || loadingApprove}
                      onClick={onCloseModal}
                    >
                      {t('newTransfer.saveAsTemplate')}
                    </Button>
                  )
                } else if (btn.sign && transactionButtonsStatus?.sign) {
                  //sign
                  btn_item = (
                    <div className={'modalButtonDivSign'}>
                      {loadingApprove ? (
                        <div className="ant-btn  exportLoadingdiv transfer_loading">
                          <Spin indicator={<SpinnerIco />} />
                        </div>
                      ) : (
                        <Button
                          size={'large'}
                          htmlType="submit"
                          className="blue-button next_btn btn flex align_center justify_center"
                          disabled={
                            (modalData.alertText !== undefined &&
                              modalData.alertText !== '') ||
                            loading
                          }
                          onClick={handleTransactionReq}
                        >
                          {t('transfers.sign')}
                        </Button>
                      )}
                    </div>
                  )
                } else if (btn.approve && transactionButtonsStatus?.approve) {
                  //approve
                  btn_item = (
                    <div className={'modalButtonDivApprove'}>
                      {loadingApprove ? (
                        <div className="ant-btn exportLoadingdiv transfer_loading">
                          <Spin indicator={<SpinnerIco />} />
                        </div>
                      ) : (
                        <Button
                          size={'large'}
                          htmlType="submit"
                          className="blue-button next_btn btn flex align_center justify_center"
                          disabled={
                            (modalData.alertText !== undefined &&
                              modalData.alertText !== '') ||
                            loading
                          }
                          onClick={() => {
                            sendTransactionRequest(
                              props.btnType || 'APPROVE',
                              false
                            )
                          }}
                        >
                          {t('transfers.approve')}
                        </Button>
                      )}
                    </div>
                  )
                } else if (
                  btn.save &&
                  transactionButtonsStatus?.save &&
                  !props.btnType
                ) {
                  //save
                  btn_item = (
                    <div>
                      {loading ? (
                        <div className="ant-btn exportLoadingdiv transfer_loading">
                          <Spin indicator={<SpinnerIco />} />
                        </div>
                      ) : (
                        <Button
                          size={'large'}
                          htmlType="submit"
                          className="blue-button next_btn btn flex align_center justify_center"
                          disabled={
                            (modalData.alertText !== undefined &&
                              modalData.alertText !== '') ||
                            loadingApprove
                          }
                          onClick={() => {
                            sendTransactionRequest(
                              props.btnType || 'SAVE',
                              false
                            )
                          }}
                        >
                          {t('newTransfer.create')}
                        </Button>
                      )}
                    </div>
                  )
                } else if (btn.send && transactionButtonsStatus?.send) {
                  //send
                  /*btn_item=<Button
                      size={'large'}
                      className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center"
                      onClick={() => { sendTransactionRequest("SIGN_AND_SEND_BANK") } }
                  >
                    İmzala və Banka göndər
                  </Button>;*/
                } else if (btn.selectAccount) {
                  //sign
                  btn_item = (
                    <Button
                      size={'large'}
                      htmlType="submit"
                      className="blue-button next_btn btn flex align_center justify_center"
                      loading={loading}
                      onClick={handleSelectAccount}
                    >
                      {t('home.chooseAccounts')}
                    </Button>
                  )
                }

                return btn_item
              })}
            <div className={'modalButtonDiv1'}>
              <Button
                size={'large'}
                htmlType="submit"
                className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center"
                disabled={loading || loadingApprove}
                onClick={onCloseModal}
              >
                {props.source ? t('common.close') : 'Ləğv et'}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  )
  const { changeStatusHandler } = useActions()

  const onClosePanel = () => {
    setPanel(!activePanel)
  }

  const onClosePanelNotify = () => {
    setPanelNotify(!activePanelNotify)
  }
  const handleOnCheck = (e, id) => {
    if (id === 'all') {
      // Əsas checkbox seçilirsə, hamısını seç və ya boşalt
      setSelectedAccounts(
        e.target.checked
          ? accounts.map((acc) => ({ iban: acc.col_1.subtitle }))
          : []
      )
    } else {
      // Seçili olanları idarə et
      setSelectedAccounts((prev) =>
        e.target.checked
          ? [...prev, { iban: id }]
          : prev.filter((item) => item.iban !== id)
      )
    }
  }
  const handleOnCheckOK =async () => {
    setRekvizitLoad(true)
    const reqlist ={
      "ibanList":selectedAccounts  
      }
     
      // const lang = localStorage.getItem('preferredLanguage')
      const data = await getRekvizitIbanRefMultiple(reqlist,selectedValue)
      downloadMultipleReq(data?.data.fileDetailsList[0].fileName, data?.data.fileDetailsList[0].fileBase64)

  }
  function downloadMultipleReq(fileName: string, fileBase64: string) {
        const linkSource = `data:application/pdf;base64,${fileBase64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        setRekvizitLoad(false)
    }
  const accountsModalFooter = () => {
    return (
      <div style={{display:'flex',justifyContent: "flex-end",alignItems: "center"}}>
        <Button
          key="ok"
          type="primary"
          disabled={selectedAccounts?.length === 0}
          loading={rekvizitLoad}
          style={{height:36}}
          className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
          onClick={() => handleOnCheckOK()}
        >
          OK
        </Button>
        
        <Button
          key="close"
          type="default"
          
          style={{height:36}}
          className="light-button refresh_btn next_modal_cancel_btn btn flex align_center justify_center"
          onClick={() =>{setSelectedAccounts([]); setAccountsModal(false)}}
        >
          Bağla
        </Button>
      </div>
    )
  }

  return (
    <>
      {accountsModal && (
        <Modal
          open={accountsModal}
          title={'Hesabları seç'}
          footer={accountsModalFooter()}
          closeIcon={<ModalCloseIco />}
          centered
          width={props.width || 700}
          onCancel={() =>{setSelectedAccounts([]); setAccountsModal(false)}}
        >
          <Scrollbar
            ref={scrollbar}
            plugins={{
              disableScroll: { direction: 'x' },
            }}
            alwaysShowTracks={true}
          >
            <Form>
              <Checkbox
                checked={selectedAccounts.length === accounts.length}
                onChange={(e) => handleOnCheck(e, 'all')}
              >
                 Bütün hesablar
              </Checkbox>
              {accounts.map((account: any) => {
                return (
                  <Checkbox
                  style={{ marginLeft:0 }}
                  checked={selectedAccounts.some(item => item.iban === account.col_1.subtitle)}
                    id={account.col_1.subtitle}
                    onChange={(e) => handleOnCheck(e, account.col_1.subtitle)}
                  >
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: 620,
                        marginLeft: '0px !important',
                      }}
                    >
                      <p style={{ width: 200, textAlign: 'start' }}>
                        {account?.col_1?.title}
                      </p>
                      <p style={{ width: 'max-content', textAlign: 'center' }}>
                        {account?.col_1.subtitle}
                      </p>
                      <p style={{ width: 200, textAlign: 'end',color:'#015CD1' }}>
                        {account?.col_3}{" "}
                        {account?.col_2}
                      </p>
                    </div>
                  </Checkbox>
                )
              })}
            </Form>
          </Scrollbar>
        </Modal>
      )}
      {nextModalVisible && (
        <Modal
          title={modalData.modalTitle}
          closeIcon={<ModalCloseIco />}
          centered
          width={props.width || 700}
          visible={nextModalVisible}
          onOk={onCloseModal}
          onCancel={onCloseModal}
          className={`manage_faster_menus swift_modal form_next_modal ${props?.className}`}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={modalFooter()}
        >
          <Scrollbar
            ref={scrollbar}
            plugins={{
              disableScroll: { direction: 'x' },
            }}
            alwaysShowTracks={true}
          >
            <Form layout="vertical" onFinish={(e) => {}} autoComplete="off">
              {/* groups */}
              {modalData.groups?.map((row) => {
                let table_class = ''

                if (row?.tableHasBorderBottom) {
                  table_class += ' has_border_bottom '
                }

                if (row?.tableHasBorderBottom2) {
                  table_class += ' has_border_bottom has_border_bottom2 '
                }

                if (row?.tableHasBordertop) {
                  table_class += ' has_border_top has_border_top2 '
                }

                if (row?.tableHasMarginBottom) {
                  table_class += ' has_margin_bottom '
                }

                return (
                  <table
                    className={`table table-hover swift_table form_next_table ${table_class}`}
                  >
                    <tbody>
                      {row.title && (
                        <tr>
                          <td
                            className={'table_title'}
                            align={'center'}
                            colSpan={2}
                          >
                            {row.currency ? (
                              <div className="currency-title">
                                <span>{row.currency}</span>
                                <span>{t('accounts.bankAccountDetails')}</span>
                              </div>
                            ) : (
                              <></>
                            )}
                            <Divider
                              plain
                              orientation="center"
                              className={'tab_divider_center'}
                            >
                              {row.title}
                            </Divider>
                          </td>
                        </tr>
                      )}

                      {row.title === '' && (
                        <tr>
                          <td
                            className={'table_title'}
                            align={'center'}
                            colSpan={2}
                          >
                            <Divider
                              plain
                              orientation="center"
                              className={'tab_divider_only'}
                            >
                              {row.title}
                            </Divider>
                          </td>
                        </tr>
                      )}

                      {row.tableHasDivider && (
                        <tr>
                          <td
                            className={'table_title'}
                            align={'center'}
                            colSpan={2}
                          >
                            <Divider
                              orientation="center"
                              className={'tab_divider_only'}
                            />
                          </td>
                        </tr>
                      )}

                      {row.data?.map((line) => {
                        return line !== undefined ? (
                          <tr className={line?.rowClass}>
                            <td>{line?.label}</td>
                            <td>{line?.value}</td>
                          </tr>
                        ) : (
                          <></>
                        )
                      })}
                    </tbody>
                  </table>
                )
              })}

              {/* edv section */}
              {modalData.edvInfoData !== null &&
              modalData.edvInfoData !== undefined ? (
                <div className={'box_row'}>
                  <div className={'flex direction_column edv_title_box'}>
                    <h3>{modalData.edvInfoData.title}</h3>
                    <p>{modalData.edvInfoData.description}</p>
                  </div>

                  <table
                    className={`table table-hover swift_table form_next_table form_next_table_transparent_row`}
                  >
                    <tbody>
                      {modalData.edvInfoData.data?.map((line) => {
                        return (
                          <tr>
                            <td>{line?.label}</td>
                            <td>{line?.value}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <></>
              )}

              {props.tableData?.PDF_LIST?.length > 0 && (
                // <div className={'pdf-div'}>
                <table
                  className={'table swift_table table_pdf modal_pdf line1069'}
                >
                  <tbody>
                    <tr>
                      <td>{t('transfers.atachedPDF')}</td>
                      <td>
                        {props.tableData?.PDF_LIST?.map((line: any) => {
                          return line?.mimeType === 'application/pdf' ? (
                            <div>
                              <a
                                type={'button'}
                                onClick={() =>
                                  props.handleGetPdfAdditional(
                                    props.tableData?.ibankRef,
                                    line?.fileName
                                  )
                                }
                              >
                                <p style={{ marginRight: 10 }}>
                                  {line?.fileName}
                                </p>
                              </a>
                            </div>
                          ) : (
                            <></>
                          )
                        })}
                      </td>
                    </tr>
                  </tbody>
                </table>
                // </div>
              )}

              {modalData?.pdfFiles?.length > 0 && (
                // <div className={'pdf-div'}>
                <table
                  className={
                    'table swift_table salary-table table_pdf modal_pdf'
                  }
                >
                  <tbody>
                    <tr>
                      <td>{t('transfers.atachedPDF')}</td>
                      <td>
                        {modalData?.pdfFiles?.map((line: any) => {
                          return (
                            <div>
                              <a
                                type={'button'}
                                onClick={() => downloadPDF(line)}
                              >
                                <p style={{ marginRight: 10 }}>{line?.label}</p>
                              </a>
                            </div>
                          )
                        })}
                      </td>
                    </tr>
                  </tbody>
                </table>
                // </div>
              )}
            </Form>
            {props.transferData && (
              <>
                <h4 className="table-title">{props.tableTitle}</h4>
                <TableComponent
                  columns={props.columnsData}
                  className={`transfer-table salary-table transfers-table__component  modal-table`}
                  data={
                    props.transferSp === true
                      ? props.tableData['TRANSACTION_EMPLIST']
                      : props.tableData
                  }
                  scroll={{ x: 0 }}
                  pagination={false}
                  rowSelection={false}
                />
              </>
            )}
            {props.innerData && (
              <>
                <h4 className="table-title">{t('transfers.notes')}</h4>
                <TableComponent
                  columns={props.innerColumnsdata}
                  className="transfer-table salary-table modal-table inner-table"
                  data={props.innerrtableData}
                  scroll={{ x: 0 }}
                  pagination={false}
                  rowSelection={false}
                />
              </>
            )}
            {props.transferSp === true && (
              <>
                <Collapse
                  style={{ marginTop: 40 }}
                  accordion
                  expandIconPosition={'end'}
                  className={'transfersCollapse collapseHistory'}
                  ghost
                  expandIcon={() => (
                    <div className={'creditCollapse__iconBox'}>
                      {activePanel ? <MinusSmallIco /> : <PlusSmallIco />}
                    </div>
                  )}
                  defaultActiveKey={activePanel ? '1' : '0'}
                  onChange={onClosePanel}
                >
                  {/*<div>*/}
                  <Panel
                    className={'creditListPanel'}
                    header={t('transfers.transferHistory')}
                    key="1"
                    extra={<div className={'line'} />}
                  >
                    <TableComponent
                      columns={props.columnsDataTransfer}
                      className="transfer-table salary-table  modal-table transfers-table__component home_account_opt_table "
                      // className="transfers-table__component home_account_opt_table transfer-table-only"
                      data={props.historyList}
                      scroll={{ x: 0 }}
                      pagination={false}
                      rowSelection={false}
                    />
                  </Panel>
                </Collapse>

                <Collapse
                  accordion
                  expandIconPosition={'end'}
                  className={'transfersCollapse'}
                  ghost
                  expandIcon={() => (
                    <div className={'creditCollapse__iconBox'}>
                      {activePanelNotify ? <MinusSmallIco /> : <PlusSmallIco />}
                    </div>
                  )}
                  onChange={onClosePanelNotify}
                  defaultActiveKey={activePanelNotify ? '1' : '0'}
                >
                  {/*<div>*/}
                  <Panel
                    className={'creditListPanel'}
                    header={t('transfers.notes')}
                    key="1"
                    extra={<div className={'line'} />}
                  >
                    {/* <h4 className="table-title">{t("transfers.notes")}</h4> */}
                    <TableComponent
                      columns={props.innerColumnsdata}
                      className="transfer-table salary-table modal-table"
                      data={props.innerrtableData}
                      scroll={{ x: 0 }}
                      pagination={false}
                      rowSelection={false}
                    />
                  </Panel>
                </Collapse>
              </>
            )}
          </Scrollbar>
        </Modal>
      )}

      {asanModalVisible && (
        <Modal
          title={`ASAN IMZA`}
          // closeIcon={<ModalCloseIco />}
          centered
          visible={asanModalVisible}
          // onOk={onClose}
          // onCancel={onClose}
          width={422}
          // bodyStyle={{height: 700}}
          className={`manage_faster_menus swift_modal form_next_modal `}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
        >
          <div className={'flex direction_column asan_sign_popup'}>
            <ul className="office-card__list">
              <li>
                <img src={asanLogo} alt="asan-logo" />
              </li>
              <li>
                <Tooltip
                  id="verificationTooltip"
                  title={text}
                  placement="topRight"
                >
                  <img src={questionMark} alt="question-mark" />
                </Tooltip>
              </li>
            </ul>

            <p>{t(LOGIN_PAGE.MESSAGE)}</p>
            <div className="office-card__statistics mt-15 mb-15">
              {t('modal.controlCode')}
              <span>{verifyCode}</span>
            </div>
            <div className="countdown">
              <CountdownCircleTimer
                isPlaying
                duration={120}
                size={80}
                strokeWidth={3}
                colors={[['#015cd1']]}
              >
                {renderTime}
              </CountdownCircleTimer>
            </div>
          </div>
        </Modal>
      )}

      {otpCodeModalVisible && (
        <Modal
          title={
            channel == 'OTP'
              ? t('transfers.signingBySMSCode')
              : t('transfers.signWithGoogleCode')
          }
          closeIcon={<ModalCloseIco />}
          centered
          visible={otpCodeModalVisible}
          onOk={hideOtpCodeModal}
          onCancel={hideOtpCodeModal}
          width={props.width || 422}
          className={`manage_faster_menus swift_modal form_next_modal otp_code_verify_modal`}
          keyboard={false}
          focusTriggerAfterClose={false}
          footer={false}
          maskClosable={false}
        >
          <div
            className={
              'flex direction_column align_center otp_code_verify_modal_body'
            }
          >
            {channel == 'OTP' ? (
              <p>
                {t('settings.otpcode1')}
                {phoneNumber} {t('settings.otpcode2')} <br />
                {t('settings.otpcode3')}
              </p>
            ) : (
              <p>{t('settings.generatedCode')}</p>
            )}
            <Form
              form={form}
              onSubmit={(e: any) => e.preventDefault()}
              onFinish={checkOTPCode}
              shouldAutoFocus={true}
              autoComplete="off"
              className={
                otpCodeHasError
                  ? 'message-input-form flex direction_column justify_center has_error'
                  : 'flex direction_column justify_center message-input-form'
              }
            >
              <OtpInput
                value={otpCode}
                onChange={handleValue}
                numInputs={otpNumberCount}
                inputStyle="otpInput"
                isInputNum={true}
                shouldAutoFocus={true}
                className="message-input-form__input"
              />

              {otpCodeHasError && (
                <span className={'verify_code_error flex full justify_center'}>
                  {t('transfers.wrongCodeEntered')}
                </span>
              )}

              <div className={'full flex direction_column'}>
                <ul
                  className="message-form__details full"
                  style={{ marginTop: otpCodeHasError ? 16 : 21 }}
                >
                  <li className="message-form__time">
                    <Timer timerEnd={resetFormTimer} reset={reset} />
                  </li>
                  <li>
                    {channel == 'OTP' && (
                      <a
                        onClick={reSend}
                        className={smsClicked ? 'active' : 'disabled'}
                      >
                        {t('modal.detailsData')}
                      </a>
                    )}
                  </li>
                </ul>

                {/*<Button*/}
                {/*  type={'ghost'}*/}
                {/*  className={'transparent resend_verify_code_btn' + smsClicked ? 'active' : 'disabled'}*/}
                {/*  onClick={reSend}*/}
                {/*>*/}
                {/*  SMS kodu yenidən göndər*/}
                {/*</Button>*/}

                <div className="login-form__buttons flex justify_center">
                  <Button
                    size={'large'}
                    className="prev ant-btn ant-btn-lg light-button refresh_btn btn flex align_center justify_center"
                    onClick={hideOtpCodeModal}
                  >
                    {t('transfers.back')}
                  </Button>
                  <Button
                    size={'large'}
                    className="next ant-btn ant-btn-lg blue-button next_btn btn flex align_center justify_center"
                    htmlType="submit"
                    loading={loading}
                  >
                    {t('login.confirm')}
                  </Button>
                </div>
              </div>
            </Form>
          </div>
        </Modal>
      )}

      {showSuccessOrError && (
        <SuccessOrErrorModal
          visible={showSuccessOrError}
          modalType={popupType}
          modalTitle={props.nextModalTitle}
          modalText={modalText}
          onClose={() => {
            onCloseSuccessModal()
            onClose()
          }}
        />
      )}
      <SaveAsTemplate
        visible={saveAsTemplatePopupVisible}
        onClose={setSaveAsTemplatePopupVisible}
        trnType={
          modalData?.modalTitle !== undefined ? modalData?.modalTitle : ''
        }
        currentForm={props.currentForm}
        tableData={props.tableData}
      />
    </>
  )
}
const mapDispatchToProps = { changeStatusHandler }

export default connect(null, null)(NextModal)
